import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const label: SxStyle = {
  textWrap: 'nowrap',
};

export const value: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,
  color: (p) => p.palette.grey['700'],
};

export const subData: SxStyle = {
  // borderWidth: '0.5px',
  // borderStyle: 'solid',
  boxShadow: (p) => `0 0 0 1px ${p.palette.primary['100']}`,
  // borderColor: (p) => p.palette.primary['100'],
  background: (p) => p.palette.primary['50'],
  fontSize: (p) => p.typography.caption.fontSize,
  borderRadius: (p) => p.spacing(0.5),
  color: (p) => p.palette.grey['500'],
  padding: (p) => p.spacing(0, 0.5),
  textWrap: 'nowrap',
};

export const skeleton: SxStyle = {
  width: '100%',
  height: (p) => p.spacing(6),
};
